import { ServiceHelper } from "./ServiceHelper";
import { URL_CONSTANTS } from "../_constants";

export const clockinService = {
    listClockIns,
    listClockinUsers,
    listVacation,
    listWorkingCalendarEntries,

    createClockIn,

    updateClockIn,
    deleteClockIn,

    uploadContract,
    deleteContract,

    updateUserSettings,

    getPdfBlobUserReport,
    getPdfBlobSummaryReport,
    getCSVBlobSummaryReport,
    getExcelBlobSummaryReport,

    requestVacation,
    deleteVacation,

    addWorkingCalendarEntry,
    deleteWorkingCalendarEntry,

    addWorkShiftSlot,
    listWorkShifts,
    deleteWorkShiftSlot,

    listAuthorizations,
};

async function getPdfBlobUserReport(locationUid, userUid, begin, end) {
    return await ServiceHelper.getPdfBlobRequest(
        URL_CONSTANTS.CLOCKINS_REPORT,
        {
            loc_uid: locationUid,
            user_uid: userUid,
            begin,
            end,
            summary: false,
        },
    );
}

async function getPdfBlobSummaryReport(locationUid, begin, end) {
    return await ServiceHelper.getPdfBlobRequest(
        URL_CONSTANTS.CLOCKINS_REPORT,
        {
            loc_uid: locationUid,
            begin,
            end,
            summary: true,
        },
    );
}

async function getCSVBlobSummaryReport(locationUid, begin, end) {
    return await ServiceHelper.getCSVBlobRequest(
        URL_CONSTANTS.CLOCKINS_REPORT_EXPORT,
        {
            loc_uid: locationUid,
            begin,
            end,
            csv: true,
        },
    );
}

async function getExcelBlobSummaryReport(locationUid, begin, end) {
    return await ServiceHelper.getExcelBlobRequest(
        URL_CONSTANTS.CLOCKINS_REPORT_EXPORT,
        {
            loc_uid: locationUid,
            begin,
            end,
            xlsx: true,
        },
    );
}

async function updateUserSettings(locationUid, userUid, allowsRemoteClockins, hasFlexibleClockins, weeklyClockinHours, monthlyClockinHours, workLocationPolicy) {
    return await ServiceHelper.putRequest(
        URL_CONSTANTS.CLOCKINS_USERS_SETTINGS,
        {
            loc_uid: locationUid,
            user_uid: userUid,
            allows_remote_clockins: allowsRemoteClockins,
            has_flexible_clockins: hasFlexibleClockins,
            weekly_clockin_hours: weeklyClockinHours,
            monthly_clockin_hours: monthlyClockinHours,
            work_location_policy: workLocationPolicy,
        },
    );
}

async function listClockIns(locationUid, begin, end, userUid) {
    return await ServiceHelper.getRequest(
        URL_CONSTANTS.CLOCKINS,
        {
            loc_uid: locationUid,
            user_uid: userUid ? userUid : undefined,
            begin,
            end,
        },
    );
}

async function listClockinUsers(locationUid, begin, end) {
    return await ServiceHelper.getRequest(
        URL_CONSTANTS.CLOCKINS_USERS,
        {
            loc_uid: locationUid,
            begin,
            end,
        },
    );
}

async function listVacation(locationUid, begin, end, userUid) {
    return await ServiceHelper.getRequest(
        URL_CONSTANTS.CLOCKINS_VACATION,
        {
            loc_uid: locationUid,
            user_uid: userUid ? userUid : undefined,
            begin,
            end,
        },
    );
}

async function listWorkingCalendarEntries(locationUid, begin, end) {
    return await ServiceHelper.getRequest(
        URL_CONSTANTS.CLOCKINS_WORKING_CALENDAR_ENTRIES,
        {
            loc_uid: locationUid,
            begin,
            end,
        },
    );
}

async function createClockIn(locationUid, userUid, date) {
    return await ServiceHelper.postRequest(
        URL_CONSTANTS.CLOCKINS,
        {
            loc_uid: locationUid,
            user_uid: userUid,
            date,
        },
    );
}

async function updateClockIn(uid, date, notes) {
    return await ServiceHelper.putRequest(
        URL_CONSTANTS.CLOCKINS + "/" + uid,
        {
            date,
            notes,
        },
    );
}

async function deleteClockIn(uid) {
    return await ServiceHelper.deleteRequest(
        URL_CONSTANTS.CLOCKINS + "/" + uid,
    );
}

async function requestVacation(locationUid, userUid, begin, end, type) {
    return await ServiceHelper.postRequest(
        URL_CONSTANTS.CLOCKINS_VACATION,
        {
            loc_uid: locationUid,
            user_uid: userUid,
            begin,
            end,
            type
        },
    );
}

async function deleteVacation(uid) {
    return await ServiceHelper.deleteRequest(
        URL_CONSTANTS.CLOCKINS_VACATION + "/" + uid,
    );
}

async function addWorkingCalendarEntry(locationUid, begin, end) {
    return await ServiceHelper.postRequest(
        URL_CONSTANTS.CLOCKINS_WORKING_CALENDAR_ENTRIES,
        {
            loc_uid: locationUid,
            begin,
            end,
        },
    );
}

async function deleteWorkingCalendarEntry(uid) {
    return await ServiceHelper.deleteRequest(
        URL_CONSTANTS.CLOCKINS_WORKING_CALENDAR_ENTRY + "/" + uid,
    );
}


async function addWorkShiftSlot(locationUid, userUid, workShiftSlots) {
    return await ServiceHelper.postRequest(
        URL_CONSTANTS.CLOCKINS_WORK_SHIFTS,
        {
            loc_uid: locationUid,
            user_uid: userUid,
            work_shifts: workShiftSlots
        },
    );
}

async function listWorkShifts(locationUid, userUid) {
    return await ServiceHelper.getRequest(
        URL_CONSTANTS.CLOCKINS_WORK_SHIFTS,
        {
            loc_uid: locationUid,
            user_uid: userUid,
        },
    );
}

async function deleteWorkShiftSlot(uid) {
    return await ServiceHelper.deleteRequest(
        URL_CONSTANTS.CLOCKINS_WORK_SHIFTS + "/" + uid,
    );
}


async function uploadContract(locationUid, userUid, file) {
    await ServiceHelper.putFilePDFRequest(
        URL_CONSTANTS.CLOCKINS_USERS_UPLOAD_CONTRACT + "/" + locationUid + "/" + userUid,
        file,
    );
}

async function deleteContract(locationUid, userUid) {
    await ServiceHelper.deleteRequest(
        URL_CONSTANTS.CLOCKINS_USERS_UPLOAD_CONTRACT + "/" + locationUid + "/" + userUid
    );
}

async function listAuthorizations(locationUid, userUid) {
    return await ServiceHelper.getRequest(
        URL_CONSTANTS.AUTHORIZATIONS,
        {
            loc_uid: locationUid,
            user_uid: userUid,
        },
    );
}